// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3mObx","logo":"Header_logo__2ins2","navItem":"Header_navItem__3h25g","navActive":"Header_navActive__1aqc0"};